<script>
import { equipmentCreateRequest } from '@api/equipment.service'
import { confirmWithPromise } from '@utils/helpers'
import { AnswerMessage } from '@utils/submit'

export default {
  props: {
    equipment: {
      type: [Number, String],
    },
  },

  methods: {
    async sendRequest() {
      if (!window.authent) {
        this.$modal.show(() => import('@app/UiElements/AuthenticationRequiredModal'), {
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        })

        return
      }

      const question = this._('Вы действительно хотите отправить заявку на презентацию данного оборудования?')

      await confirmWithPromise(question, this)

      const formdata = {
        phone: window.request_phone,
        equipment: this.equipment,
      }

      equipmentCreateRequest.execute({}, formdata).then(() => {
        const meta = { message: { title: this._('Ваша заявка успешно отправлена') } }

        AnswerMessage(meta, this)
      })
    },
  },

  render(h) {
    return this.$scopedSlots.default({
      sendRequest: this.sendRequest,
    })
  },
}
</script>
